import { Visibility } from '../visibility/visibility.types';

export type Fieldset = {
  position: number;
  title: string;
  assignedOffersCount: number;
  name: string;
  category: string;
  id: number;
  custom: boolean;
  default: boolean;
  updatedAt: string;
  fields: FieldTemplate[];
};

export type FieldTemplate = {
  id?: number | null;
  name: string;
  kind: FieldKind;
  options?: { values?: string[] };
  position?: number;
  visibility: Visibility | null;
  visible?: boolean;
};

export enum FieldKind {
  SingleLine = 'single_line',
  MultiLine = 'multi_line',
  Dropdown = 'dropdown',
  Boolean = 'boolean',
  Date = 'date',
  DateOfBirth = 'date_of_birth',
  Address = 'address',
  Education = 'education',
  Experience = 'experience',
  Gender = 'gender',
  Nationality = 'nationality',
  LanguageSkill = 'language_skill',
  Skills = 'skills',
}
